import React, {ReactElement} from "react";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import classes from './Skills.module.scss'
import {useViewportSize} from "../../hooks/useViewportSize";
import {range} from "../../helpers/math";

interface Props {
	name?: string,
	percent?: number
}

export const Skill = (props: Props): ReactElement<Props> => {
	const {width} = useViewportSize();
	const max = width > 960 ? 7 : 4;

	return (
		<div className={classes.skill}>
			<h4 className={classes.text}>{props.name}</h4>
			<ProgressBar
				maxLength={max}
				fill={Math.ceil(range(0, 100, 0, max, props.percent || 0))}
				className={classes.progress}
			/>
		</div>
	)
}